export const assetResolver = assetName => `https://assets.spyscape.net/navigation/${assetName}`;

export const isActiveLink = link => window.location.href === link
|| window.location.pathname === link;

export const showSecondaryNav = data => data?.secondaryMenu?.length > 0;
